/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_GROUP_TYPES_LIST,
  GET_GROUP_TYPES_LIST_SUCCESS,
  GET_GROUP_TYPES_LIST_ERROR,
  CLEAR_GROUP_TYPES_LIST,
  SET_CURRENT_NAVIGATION_TAB,
  SET_GROUP_TYPES_QUERY,
  SET_BACK_TO_GROUP_TYPES_LIST,
  SET_VISIBLE_MODAL_FORM_NUMBER,
  SET_VALUES_FORM_APPLY_SHARE_CODE,
  VERIFY_CODE,
  VERIFY_CODE_SUCCESS,
  VERIFY_CODE_ERROR,
  APPLY_SHARE_CODE,
  APPLY_SHARE_CODE_SUCCESS,
  APPLY_SHARE_CODE_ERROR,
  SET_MODAL_MESSAGE,
} from 'src/actions/groupSettingsActions';

const initialCurrentNavigationTab = 'groupTypes';
const backToGroupTypesList = {
  groupTypes: [],
  query: {},
  active: false,
  comeBack: false,
};
const formApplyShareCode = {
  loading: false,
  shareCode: '',
  validCode: true,
  groupTypeOwnerFirstName: '',
  groupTypeOwnerLastName: '',
  groupTypeName: '',
};

const modalMessage = {
  isVisible: false,
  modalTitle: null,
  modalBody: '',
};

const initialState = {
  currentNavigationTab: initialCurrentNavigationTab,
  groupTypes: [],
  selectedGroupTypes: [],
  query: {
    status: 'Active',
  },
  loading: false,
  backToGroupTypesList,
  formApplyShareCode,
  visibleModalFormNumber: null,
  modalMessage,
};

const groupSettingsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_GROUP_TYPES_LIST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_GROUP_TYPES_LIST_SUCCESS: {
      return produce(state, (draft) => {
        draft.groupTypes = payload?.groupTypes || [];
        draft.loading = false;
      });
    }

    case GET_GROUP_TYPES_LIST_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case CLEAR_GROUP_TYPES_LIST: {
      return produce(state, (draft) => {
        draft.groupTypes = initialState.groupTypes;
      });
    }

    case SET_CURRENT_NAVIGATION_TAB: {
      return produce(state, (draft) => {
        draft.currentNavigationTab = payload || initialCurrentNavigationTab;
      });
    }

    case SET_GROUP_TYPES_QUERY: {
      return produce(state, (draft) => {
        draft.query = payload ? {
          ...state.query,
          ...payload
        } : initialState.query;
      });
    }

    case SET_BACK_TO_GROUP_TYPES_LIST: {
      return produce(state, (draft) => {
        draft.backToGroupTypesList = payload ? {
          ...state.backToGroupTypesList,
          ...payload,
        } : backToGroupTypesList;
      });
    }

    case SET_VISIBLE_MODAL_FORM_NUMBER: {
      return produce(state, (draft) => {
        draft.visibleModalFormNumber = payload || null;
      });
    }

    case SET_MODAL_MESSAGE: {
      return produce(state, (draft) => {
        draft.modalMessage = {
          ...state.modalMessage,
          ...payload,
        };
      });
    }

    case VERIFY_CODE: {
      return produce(state, (draft) => {
        draft.formApplyShareCode.loading = true;
      });
    }

    case VERIFY_CODE_SUCCESS: {
      return produce(state, (draft) => {
        draft.formApplyShareCode.validCode = true;
        draft.formApplyShareCode.loading = false;
        draft.formApplyShareCode.groupTypeOwnerFirstName = payload?.groupTypeOwnerFirstName || [];
        draft.formApplyShareCode.groupTypeOwnerLastName = payload?.groupTypeOwnerLastName || [];
        draft.formApplyShareCode.groupTypeName = payload?.groupTypeName || [];
      });
    }

    case VERIFY_CODE_ERROR: {
      return produce(state, (draft) => {
        draft.formApplyShareCode.loading = false;
        draft.formApplyShareCode.validCode = false;
      });
    }

    case SET_VALUES_FORM_APPLY_SHARE_CODE: {
      return produce(state, (draft) => {
        draft.formApplyShareCode = payload ? {
          ...state.formApplyShareCode,
          ...payload,
        } : formApplyShareCode;
      });
    }

    case APPLY_SHARE_CODE: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case APPLY_SHARE_CODE_SUCCESS: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case APPLY_SHARE_CODE_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default groupSettingsReducer;
